export interface Lote {
  idLote: number;
  numeroLote: string;
  idArticulo: number;
  descripcion?: string;
  fechaFabricacion?: string | null;
  fechaVencimiento?: string | null;
  cantidadInicial?: number | null;
  cantidadActual?: number | null;
  observaciones?: string;
  activo: boolean;
  fechaCreacion?: string;
  articuloCodigo?: string;
  articuloDescripcion?: string;
}

export const initialLoteState: Lote = {
  idLote: 0,
  numeroLote: '',
  idArticulo: 0,
  activo: true,
};
